import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, Box, Typography } from '@mui/material';
import { getMyFrusMyEvents } from '../../../../helpers/RescuesHelper';
import RescuerEventMobileCard from '../Rescues/myFrus/RescuerEventMobileCard';
import useActiveUser from '../../../../hooks/useActiveUser';
import useRescuerDashboardActions from '../../../../hooks/useRescuerDashboardActions';
import { fetchSiteEvents } from '../../../../actions/sites';
import useActiveSite from '../../../../hooks/useActiveSite';

const containerSx = {
  position: 'relative',
  height: '100%',
  width: '100%',
  overflow: 'auto',
  backgroundColor: 'background.default',
};

const MyEvents = () => {
  const activeUser = useActiveUser();
  const activeSite = useActiveSite();
  const dispatch = useDispatch();
  const eventsEntities = useSelector((state) => state.entities.events);
  const eventsList = getMyFrusMyEvents(eventsEntities, activeUser.id);
  const { fetchMyEvents } = useRescuerDashboardActions();

  useEffect(() => {
    fetchMyEvents(false, true);
    dispatch(fetchSiteEvents(activeSite.id));
  }, [fetchMyEvents]);

  if (!eventsList.inflight && eventsList.events.length === 0) {
    return (
      <Box sx={containerSx}>
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            WebkitTransform: 'translate(-50%, -50%)',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography color="textSecondary" variant="h5">
            You are not participating in any event.
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <List sx={containerSx} subheader={<li />}>
      <li style={{ backgroundColor: 'inherit' }}>
        <Box component="ul" sx={{ marginBottom: 3, backgroundColor: 'inherit', padding: 0 }}>
          {!eventsList.inflight &&
            eventsList.events.map((event) => (
              <ListItem key={`events-${event.id}`} sx={{ display: 'block', padding: 1 }}>
                <RescuerEventMobileCard eventData={event} />
              </ListItem>
            ))}
        </Box>
      </li>
    </List>
  );
};

export default MyEvents;
